import ExplorerPage from "@/components/products/explorer/ExplorerPage"

type Props = {}

const index = (_props: Props) => {
  return <ExplorerPage />
}

export default index
